import { array, number, object, string } from "superstruct";

export const RewardsFaqSchema = object({
    id: number(),
    title: string(),
    body: string(),
    position: number(),
});

export const RewardsFaqListResponseSchema = object({
    faqs: array(RewardsFaqSchema),
});
